import "./App.css";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import ProtectedRoute from "./Components/Protected Route/ProtectedRoute";
import InternalServerError from "./Components/Errors Handling/Error 500/InternalServerError.jsx";
import Error404 from "./Components/Errors Handling/Error 404/Error404.jsx";
import Layout from "./Components/layout/Layout.jsx";
import SlugChecker from "./Components/SlugChecker/SlugChecker.jsx";
import AuthForm from "./Components/Screens/Login/auth.jsx";
import Home from "./Components/Screens/Home/Home.jsx";
import Booking from "./Components/Screens/Booking/Booking.jsx";
import MyBookings from "./Components/Screens/MyBookings/MyBookings.jsx";
import UserProfile from "./Components/Screens/UserProfile/UserPRofile.jsx";
import Settings from "./Components/Screens/Settings/SettingsScreen.jsx";
import { GoogleOAuthProvider } from "@react-oauth/google";
import ScheduleManagement from "./Components/Screens/Reminer/Reminder.jsx";
import BlogsSection from "./Components/HomeSections/BlogsSection.jsx";
import OurServices from "./Components/HomeSections/OurServices.jsx";
import ClinicsSection from "./Components/HomeSections/DoctorInfo.jsx";
import PackagePurchase from "./Components/HomeSections/Packages.jsx";
import BlogDetails from "./Components/Screens/BlogDetails/BlogDetails.jsx"; // Import the new BlogDetails component
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "./context/LanguageContext";
import NewComingSoon from "./Components/Screens/CommingSoon/NewCommingSoon.jsx";
import ContactUs from "./Components/HomeSections/ContactUS.jsx";
import PublicContact from "./Components/Screens/PublicContact/PublicContact.jsx";
import PublicLayout from "./Components/PublicLayout/PublicLayout.jsx";

function App() {
  const routers = createBrowserRouter([
 {
      element: <PublicLayout />,
      children: [
        { path: "/",          element: <NewComingSoon /> },
        { path: "contant-us",  element: <PublicContact /> },
      ],
    },
    
    {
      path: "/:slug",
      element: <SlugChecker />,
      children: [
        { path: "auth", element: <AuthForm /> },
        { path: "login", element: <AuthForm active={"login"}/> },
        { path: "sign-up", element: <AuthForm active={"signup"} /> },
        {  path: "contact-us", element: <ContactUs /> },
        
        {
          path: "",
          element: <Layout />,
          children: [
            { path: "home", element: <Home /> },
            { index: true, element: <Home /> },
            { path: "book-appointment", element: <Booking /> },
            { path: "blogs", element: <BlogsSection /> },
            { path: "blog/:id", element: <BlogDetails /> },
            { path: "services", element: <OurServices /> },
            
            { path: "clinics", element: <ClinicsSection /> },
            { path: "packages", element: <PackagePurchase /> },
            { path: "my-appointments", element: <ProtectedRoute><MyBookings /></ProtectedRoute> },
            { path: "schedule-reminder", element: <ProtectedRoute><ScheduleManagement /></ProtectedRoute> },
            { path: "user-profile", element:<ProtectedRoute><UserProfile /></ProtectedRoute>  },
            { path: "settings", element:<ProtectedRoute><Settings /></ProtectedRoute>  },
          ],
        },
      ],
    },
    { path: "server-error", element: <InternalServerError /> },
    { path: "not-found", element: <Error404 /> },
    { path: "*", element: <Error404 /> },
  ]);

  return (
    <HelmetProvider>
      <LanguageProvider>
        <GoogleOAuthProvider clientId="540631881814-0fv2ofvnb2tsb002i7n917it0moe6ev0.apps.googleusercontent.com">
          <RouterProvider router={routers} />
        </GoogleOAuthProvider>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;